(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('liitt-sale-countdown')) {
  customElements.define('liitt-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      const now = Date.now();
      // Fixed sale deadline from the section's "sale end" setting — shared by every
      // visitor, counts down to a real date (honest urgency). If that date is blank
      // or already past, fall back to the rolling 10-minute per-visitor timer.
      const fixedAttr = this.getAttribute('data-deadline');
      const fixed = fixedAttr ? Date.parse(fixedAttr) : NaN;
      if (Number.isFinite(fixed) && fixed > now) {
        this.deadline = fixed;
      } else {
        const timerKey = 'liitt_halloween_timer_v1';
        const visitKey = 'liitt_halloween_visit_v1';
        const duration = 10 * 60 * 1000;
        this.deadline = now + duration;
        try {
          const previous = Number(localStorage.getItem(timerKey));
          const continuingVisit = sessionStorage.getItem(visitKey) === '1';
          const validPrevious = Number.isFinite(previous) && previous > 0 && previous <= now + duration;
          if (validPrevious && (previous > now || continuingVisit)) this.deadline = previous;
          sessionStorage.setItem(visitKey, '1');
          localStorage.setItem(timerKey, String(this.deadline));
        } catch (error) {
          // Storage can be unavailable in private browsing; keep this page's timer working.
        }
      }
      this.days = this.querySelector('[data-countdown-days]');
      this.daysWrap = this.querySelector('[data-countdown-days-wrap]');
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');
      if (!this.days || !this.daysWrap || !this.hours || !this.minutes || !this.seconds) return;
      this.resume = () => this.updateTime();
      document.addEventListener('visibilitychange', this.resume);
      window.addEventListener('pageshow', this.resume);
      this.updateTime();
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
      document.removeEventListener('visibilitychange', this.resume);
      window.removeEventListener('pageshow', this.resume);
    }

    updateTime() {
      clearTimeout(this.timeout);
      const milliseconds = this.deadline - Date.now();
      const remaining = Math.max(0, Math.ceil(milliseconds / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      this.days.textContent = String(days).padStart(2, '0');
      this.hours.textContent = String(hours).padStart(2, '0');
      this.minutes.textContent = String(minutes).padStart(2, '0');
      this.seconds.textContent = String(seconds).padStart(2, '0');
      this.hidden = false;
      if (remaining > 0 && !document.hidden) this.timeout = setTimeout(() => this.updateTime(), 1000 - (Date.now() % 1000));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
